import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { BRANDS } from "../config/brands";
import { useBrand } from "../context/BrandContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
  },
  card: {
    width: "100%",
    maxWidth: 400,
  },
  cardContent: {
    padding: theme.spacing(3),
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
    textAlign: "center",
    fontWeight: "bold",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  brandSelector: {
    marginBottom: theme.spacing(2),
  },
  hint: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    color: "#999",
    fontSize: 12,
  },
}));

export const LoginPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const { selectedBrand, setSelectedBrand } = useBrand();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [localBrand, setLocalBrand] = useState(selectedBrand || "ht");

  const handleBrandChange = (event) => {
    setLocalBrand(event.target.value);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    if (!localBrand) {
      setError("Por favor selecciona una marca");
      setLoading(false);
      return;
    }

    if (!formData.email || !formData.password) {
      setError("El email y contraseña son requeridos");
      setLoading(false);
      return;
    }

    try {
      const brandConfig = BRANDS[localBrand];
      if (!brandConfig) {
        throw new Error("Marca inválida");
      }

      const response = await fetch(brandConfig.apiUrl + "/admin/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email,
          password: formData.password,
        }),
      });

      if (response.status < 200 || response.status >= 300) {
        throw new Error("Email o contraseña inválidos");
      }

      const auth = await response.json();

      // Persistir el brand seleccionado
      setSelectedBrand(localBrand);

      // Guardar el token
      localStorage.setItem("admin-token", auth.token);

      // Redirigir al dashboard del brand
      history.push(`/${localBrand}/`);
    } catch (err) {
      setError(err.message || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography variant="h5" className={classes.title}>
            Panel Administrativo
          </Typography>

          {error && (
            <Box
              sx={{
                padding: "12px",
                backgroundColor: "#ffebee",
                border: "1px solid #ef5350",
                borderRadius: "4px",
                color: "#c62828",
                marginBottom: "16px",
              }}
            >
              {error}
            </Box>
          )}

          <TextField
            select
            label="Selecciona una marca"
            value={localBrand}
            onChange={handleBrandChange}
            fullWidth
            className={classes.brandSelector}
            disabled={loading}
          >
            {Object.entries(BRANDS).map(([key, config]) => (
              <option key={key} value={key}>
                {config.name}
              </option>
            ))}
          </TextField>

          <form onSubmit={handleLogin} className={classes.form}>
            <TextField
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              fullWidth
              disabled={loading}
            />
            <TextField
              label="Contraseña"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              fullWidth
              disabled={loading}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              className={classes.button}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Iniciar Sesión"}
            </Button>
          </form>

          <Typography className={classes.hint}>
            Usuario: admin@example.com | Contraseña: password
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
